import { UploadsPopover, UploadsTriggerButton } from '@cinesend/ui-kit'
import { useContext } from 'react'
import { StoreContext } from '../../contexts/store'

function uploadItems(transfers) {
  return transfers.map((transfer) => {
    const total = transfer.total_bytes ?? 0
    const current = transfer.current_bytes ?? 0

    return {
      id: String(transfer.id),
      name: transfer.name ?? 'Upload',
      status: total > 0 && current >= total ? 'complete' : 'uploading',
    }
  })
}

export default function Transfers() {
  const { state } = useContext(StoreContext)
  const items = uploadItems(state.transfers)
  const uploading = items.some((item) => item.status === 'uploading')

  return <UploadsPopover align='end' items={items} trigger={<UploadsTriggerButton uploading={uploading} />} />
}
